import { useUiPreferences } from '../useUiPreferences';
import { ActionRow, Section, TextRow, ToggleRow } from '../SettingsRows';

const DEFAULTS = {
    'ui.network.transcode_cache': 'true',
    'ui.network.external_url': '',
    'ui.network.force_https': 'false',
    'ui.network.remote_access': 'false',
};

export function NetworkTab(): React.JSX.Element {
    const [prefs, save] = useUiPreferences(DEFAULTS);

    return (
        <>
            <Section title="Storage">
                <ToggleRow
                    label="Transcode cache"
                    desc="Keep converted files for slower clients."
                    value={prefs['ui.network.transcode_cache'] === 'true'}
                    onChange={(v) => save({ 'ui.network.transcode_cache': String(v) })}
                />
                <ActionRow label="Clear transcode cache" desc="Removes cached conversions from disk." actionLabel="Clear" tone="danger" />
            </Section>
            <Section title="Access">
                <TextRow
                    label="External address"
                    desc="Used when you listen away from home."
                    value={prefs['ui.network.external_url']}
                    onChange={(v) => save({ 'ui.network.external_url': v })}
                    placeholder="https://musiceer.example.com"
                />
                <ToggleRow
                    label="Force HTTPS"
                    desc="Redirect plain connections to TLS."
                    value={prefs['ui.network.force_https'] === 'true'}
                    onChange={(v) => save({ 'ui.network.force_https': String(v) })}
                />
                <ToggleRow
                    label="Remote access"
                    desc="Reachable from outside your network."
                    value={prefs['ui.network.remote_access'] === 'true'}
                    onChange={(v) => save({ 'ui.network.remote_access': String(v) })}
                />
            </Section>
        </>
    );
}
